<template>
  <article name="cartItem" class="columns is-multiline cart-item--checkout">
    <div class="column is-3 is-hidden-mobile">
      <figure aria-hidden="true">
        <p class="image is-96x96 u-is-64x64--mobile mt-2">
          <router-link :to="{ name: 'redirect-to-offer', params: { id: item.variantId } }" tabindex="-1">
            <img fetchpriority="low" class="c-cartdrawer__img"
              v-lazy="`https://assets.urlaubsgutschein.kaufen/i/resize?width=100&quality=50&interlace=true&type=auto&file=${item.image}`"
              :alt="item.subtitle" loading="lazy" />
          </router-link>
        </p>
      </figure>
    </div>
    <div class="column is-9">
      <div class="columns u-is-vend is-gapless is-multiline">
        <div class="column is-12 ">
          <div class="has-text-weight-semibold u-text--ellipsis">
            <router-link class="has-text-black-ter" :to="{ name: 'redirect-to-offer', params: { id: item.variantId } }">
              {{
                item.title }}</router-link>
          </div>
          <div class="u-text--ellipsis">
            <small class="is-block u-text--ellipsis">{{ item.subtitle }}</small>
            <small class="is-block u-text--ellipsis">{{ item.description }}</small>
          </div>
          <div class="columns is-vcentered is-mobile is-gapless c-cartdrawer_itemoptions is-multiline">
            <div class="column is-5-tablet is-7-mobile">
              <b-field>
                <b-numberinput :aria-label="$t('general.quantity')" :name="$t('general.quantity')"
                  controls-position="compact" v-model="item.quantity" size="is-small" type="is-dark" min="1" max="10"
                  @input="changeQuantity" :aria-minus-label="$t('general.decrease-quantity')"
                  :aria-plus-label="$t('general.increase-quantity')"></b-numberinput>
              </b-field>
            </div>
            <div class="column is-3-tablet is-5-mobile is-size-7 has-text-right-mobile">à {{ item.currency | currency }}
              {{ item.unitPrice | amount }}</div>
            <div class="column is-4-tablet is-12-mobile has-text-right">
              <b-button name="removeButton" type="is-text" @click="removeItem" class="is-size-7">
                <span class="is-sr-only">{{ $t('general.offer') }}</span>
                {{ $t('general.remove') }}
              </b-button>
            </div>
          </div>
          <!-- VERSICHERUNG  START -->
          <div class="columns is-vcentered is-mobile is-gapless c-cartdrawer_itemoptions is-multiline"
            v-for="upgrade in item.upgrades" :key="upgrade.id">
            <div class="column is-8-tablet is-7-mobile is-size-7">{{ upgrade.description }} ({{ item.currency | currency
            }} {{ upgrade.unitPrice | amount }})</div>
            <div class="column is-4-tablet is-5-mobile has-text-right">
              <b-button v-if="upgrade.unitPrice > 0" name="removeInsuranceButton" type="is-text"
                @click="removeInsurance" class="is-size-7">{{ $t('general.remove') }}</b-button>
            </div>
          </div>
          <!-- VERSICHERUNG  END -->
        </div>
        <div class="column is-12 is-size-5 has-text-right">
          <small class="is-size-7" v-if="item.orderItemReduction"> {{ $t('general.instead-of') }} {{ item.currency |
            currency }} {{ (item.orderItemReduction.unitPriceBeforeReduction * item.quantity) | amount }} </small>
          <span class="is-sr-only">{{ $t('general.total-price-of-offer') }}</span>
          <strong class="is-block">{{ item.currency | currency }} {{ item.total | amount }}</strong>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'CartItem',
  props: {
    item: Object,
  },
  methods: {
    removeItem() {
      this.$store.dispatch('removeProduct', this.item)
    },
    changeQuantity(val) {
      this.$store.dispatch('changeQuantityOfProduct', { itemId: this.item.id, quantity: val })
    },
  },
}
</script>

<style lang="scss">
.cart-item--checkout {
  .b-numberinput {
    input {
      border-color: #363636;
    }
  }
}
</style>

<style lang="scss" scoped>
.u-text--ellipsis {
  a:focus-visible {
    outline-offset: -2px !important;
  }
}
</style>
